module.exports = __webpack_public_path__ + "static/media/vspacefloor1.071ea20d.png";